import { EOrderStatus } from "constants/enums"

import { cn } from "components/lib/utils"

export enum AcStatusType {
    CREATED = EOrderStatus.created,
    FAILED = EOrderStatus.payment_failed,
    DISPUTE_LOST = EOrderStatus.payment_dispute_lost,
    PENDING = EOrderStatus.payment_pending,
    REFUND_PENDING = EOrderStatus.payment_refund_pending,
    PAYMENT_EXPIRED = EOrderStatus.payment_expired,
    SUCCEEDED = EOrderStatus.charge_succeed,
    DISPUTE_WON = EOrderStatus.payment_dispute_won,
    CANCELED = EOrderStatus.payment_canceled,
    DISPUTE_OPEN = EOrderStatus.payment_dispute_open,
    DISPUTE_CANCELED = EOrderStatus.payment_refund_cancelled,
    REFUNDED = EOrderStatus.payment_refunded,
    EVIDENCE_SUBMITTED = EOrderStatus.payment_dispute_evidence_submitted,
    CHARGE_PENDING = EOrderStatus.charge_pending,
    CHARGE_FAILED = EOrderStatus.charge_failed,
    REFUND_REQUIRES_ACTION = EOrderStatus.payment_refund_requires_action,
    REFUND_FAILED = EOrderStatus.payment_refund_failed,
    REFUND_CANCELED = EOrderStatus.payment_refund_canceled,
    DISPUTE_INQUIRY_OPEN = EOrderStatus.payment_dispute_inquiry_open,
    DISPUTE_INQUIRY_EVIDENCE_SUBMITTED = EOrderStatus.payment_dispute_inquiry_evidence_submitted,
    DISPUTE_INQUIRY_WON = EOrderStatus.payment_dispute_inquiry_won,
}

const StatusesMap: Record<AcStatusType, string> = {
    [AcStatusType.CREATED]: 'Created',
    [AcStatusType.FAILED]: 'Failed (not charged)',
    [AcStatusType.DISPUTE_LOST]: 'Dispute Lost (charged)',
    [AcStatusType.PENDING]: 'Pending',
    [AcStatusType.REFUND_PENDING]: 'Refund Pending',
    [AcStatusType.SUCCEEDED]: 'Succeeded',
    [AcStatusType.DISPUTE_WON]: 'Dispute Won',
    [AcStatusType.CANCELED]: 'Canceled',
    [AcStatusType.DISPUTE_OPEN]: 'Dispute Open',
    [AcStatusType.DISPUTE_CANCELED]: 'Dispute Canceled',
    [AcStatusType.PAYMENT_EXPIRED]: 'Payment Expired',
    [AcStatusType.REFUNDED]: 'Refunded',
    [AcStatusType.EVIDENCE_SUBMITTED]: 'Evidence Submitted',
    [AcStatusType.CHARGE_PENDING]: 'Charge Pending',
    [AcStatusType.CHARGE_FAILED]: 'Charge Failed',
    [AcStatusType.REFUND_REQUIRES_ACTION]: 'Refund Requires Action',
    [AcStatusType.REFUND_FAILED]: 'Refund Failed',
    [AcStatusType.REFUND_CANCELED]: 'Refund Canceled',
    [AcStatusType.DISPUTE_INQUIRY_OPEN]: 'Inquiry Open',
    [AcStatusType.DISPUTE_INQUIRY_EVIDENCE_SUBMITTED]: 'Inquiry Evidence Submitted',
    [AcStatusType.DISPUTE_INQUIRY_WON]: 'Inquiry Won',
}

const ColorsMap: Record<AcStatusType, string> = {
    [AcStatusType.REFUNDED]: 'text-green-500 bg-green-50',
    [AcStatusType.SUCCEEDED]: 'text-green-500 bg-green-50',
    [AcStatusType.DISPUTE_WON]: 'text-green-500 bg-green-50',
    [AcStatusType.DISPUTE_INQUIRY_WON]: 'text-green-500 bg-green-50',
    [AcStatusType.FAILED]: 'text-rose-600 bg-rose-50',
    [AcStatusType.CHARGE_FAILED]: 'text-rose-600 bg-rose-50',
    [AcStatusType.REFUND_FAILED]: 'text-rose-600 bg-rose-50',
    [AcStatusType.DISPUTE_LOST]: 'text-rose-600 bg-rose-50',
    [AcStatusType.PENDING]: 'text-orange-500 bg-orange-50',
    [AcStatusType.REFUND_PENDING]: 'text-orange-500 bg-orange-50',
    [AcStatusType.CHARGE_PENDING]: 'text-orange-500 bg-orange-50',
    [AcStatusType.EVIDENCE_SUBMITTED]: 'text-orange-500 bg-orange-50',
    [AcStatusType.DISPUTE_INQUIRY_EVIDENCE_SUBMITTED]: 'text-orange-500 bg-orange-50',
    [AcStatusType.REFUND_REQUIRES_ACTION]: 'text-orange-500 bg-orange-50',
    [AcStatusType.CREATED]: 'text-blue-950 bg-blue-50',
    [AcStatusType.DISPUTE_OPEN]: 'text-blue-950 bg-blue-50',
    [AcStatusType.DISPUTE_INQUIRY_OPEN]: 'text-blue-950 bg-blue-50',
    [AcStatusType.PAYMENT_EXPIRED]: 'text-neutral-700 bg-neutral-100',
    [AcStatusType.CANCELED]: 'text-neutral-700 bg-neutral-100',
    [AcStatusType.REFUND_CANCELED]: 'text-neutral-700 bg-neutral-100',
    [AcStatusType.DISPUTE_CANCELED]: 'text-neutral-700 bg-neutral-100',
}

interface AcCellStatusProps {
    theme: 'dark' | 'light'
    type: AcStatusType
}

export const AcCellStatus = ({ type }: AcCellStatusProps) => {
    const colors = ColorsMap[type]
    const label = StatusesMap[type]

    if (!colors || !label) return null

    return (
        <div
            className={cn(
                'rounded-full px-2 py-1 text-p-xs flex justify-center items-center max-w-fit',
                colors
            )}
        >
            {label}
        </div>
    )
}